import React from 'react'
import { css } from '@emotion/core'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

type ComponentProps = {
  error?: boolean
  maxWidth?: number
} & React.ComponentPropsWithoutRef<'textarea'>

const FrontTabletTextArea = React.forwardRef<HTMLTextAreaElement, ComponentProps>(({ error, maxWidth, ...props }, ref) => {
  return <textarea {...props} ref={ref} css={[textAreaStyle, maxWidth && css({ maxWidth }), error && errorTextAreaStyle]} />
})
FrontTabletTextArea.displayName = 'FrontTabletTextArea'
export { FrontTabletTextArea }

const textAreaStyle = css(
  {
    width: '100%',
    textAlign: 'left',
    borderRadius: 10,
    border: '1px solid #CCCCCC',
    padding: 16,
    fontSize: FrontTabletFontSize.formInput,
    lineHeight: 1.5,
    '::placeholder': {
      color: '#CCCCCC',
    },
  },
  createSelfCheckinBaseStyle({ fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape11 }),
  createSelfCheckinResponsiveStyle({
    landscape13: {
      fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13,
      padding: 20,
    },
  }),
)

const errorTextAreaStyle = css({
  borderColor: '#ff2700 !important',
})
